import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { IAppStore } from 'stores/AllStores';

// Styles
const s = require('./GroupCreate.css');

// Props
interface ICreateGroupProps {
  store?: IAppStore;
}

// Component
@inject('store')
@observer
export class GroupCreate extends React.Component<ICreateGroupProps, {}> {
  constructor(props: ICreateGroupProps) {
    super(props);
  }

  public render() {
    // Destructure
    const { createNewGroup } = this.props.store.leadGroup;

    // Render
    return (
      <div className={s.createGroup}>
        <input
          type="text"
          placeholder="Group name..."
          autoFocus={true}
          value={createNewGroup}
          onChange={this.handleChangeGroupName}
        />
        <button className="boxButton" onClick={this.handleCreateGroup}>
          Create new group
        </button>
      </div>
    );
  }

  private handleChangeGroupName = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.props.store.leadGroup.createNewGroup = e.currentTarget.value;
  };

  private handleCreateGroup = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.props.store.leadGroup.createLeadGroup();
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.tsx